import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import {
	TPpwrCountryExclusionsResponsePayload,
	TPpwrManualReportingResponsePayload,
	TPpwrPackingTypesResponsePayload,
	TPpwrStore,
} from './types';

const getPpwrState = (state: TStoreState): TPpwrStore => state.ppwr;

export const getPpwr = getPpwrState;

export const getPpwrPackingTypes = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): TPpwrPackingTypesResponsePayload => ppwr.packingTypes,
);

export const getPpwrPackingTypesIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.packingTypesLoading,
);

export const getPpwrUpdatePackingTypeWeightIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.updatePackingTypeWeightLoading,
);

export const getPpwrUpdatePackingTypeEnabledIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.updatePackingTypeEnabledLoading,
);

export const getPpwrUploadProofDocumentIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.uploadProofDocumentLoading,
);

export const getPpwrDeleteProofDocumentIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.deleteProofDocumentLoading,
);

export const getPpwrDownloadProofDocumentIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.downloadProofDocumentLoading,
);

export const getPpwrCountryExclusions = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): TPpwrCountryExclusionsResponsePayload => ppwr.countryExclusions,
);

export const getPpwrCountryExclusionsIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.countryExclusionsLoading,
);

export const getPpwrSaveCountryExclusionIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.saveCountryExclusionLoading,
);

export const getPpwrManualReporting = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): TPpwrManualReportingResponsePayload => ppwr.manualReporting,
);

export const getPpwrManualReportingIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.manualReportingLoading,
);

export const getPpwrUpsertManualReportIsLoading = createSelector(
	[getPpwr],
	(ppwr: TPpwrStore): boolean => ppwr.upsertManualReportLoading,
);
